
window.LandingPage = ReactiveComponent
  displayName: 'LandingPage'

  render: -> 
    loc = fetch 'location'

    w = SAAS_PAGE_WIDTH()
    mobile = w < 830

    DIV 
      style: 
        color: 'white'        

      DIV 
        style: 
          paddingTop: 32
          width: SAAS_PAGE_WIDTH()
          margin: 'auto'
          


        H1 
          style: 
            color: 'white'  
            maxWidth: 1050
            margin: 'auto'

          DIV 
            style: 
              fontStyle: 'oblique'
              fontWeight: 100
              fontSize: if mobile then 20 else 28         
            'Consider.it creates'

          DIV 
            style: 
              fontSize: if mobile then 32 else 50            
              fontWeight: 700
              textAlign: 'left'  
              textShadow: '0px 1px 2px rgba(0,0,0,.2)'
              fontStyle: 'oblique'
              textTransform: 'uppercase'

            if SAAS_PAGE_WIDTH() < 1040
              'Civil and organized online dialogue'
            else 

              "CIVIL, ORGANIZED, AND EFFICIENT ONLINE DIALOGUE"

          DIV 
            style: 
              fontStyle: 'oblique'
              fontWeight: 100
              fontSize: if mobile then 20 else 28         
              textAlign: 'right'
            'by visually summarizing what your community thinks and why'



        DIV 
          style: 
            textAlign: 'center'
            paddingTop: 24        
            position: 'relative'
            top: 8

          Demo
            width: Math.min 1050, SAAS_PAGE_WIDTH()

        DIV 
          style: 
            fontStyle: 'oblique'
            fontWeight: 100
            textAlign: 'center'
            fontSize: if mobile then 16 else 20
            paddingTop: 18
            paddingBottom: 32

          'The City of Seattle is one of many to trust Consider.it with community and stakeholder engagement'
      

      DIV 
        style: 
          fontSize: if mobile then 28 else 36
          fontWeight: 400
          width: SAAS_PAGE_WIDTH()
          maxWidth: 1020
          textAlign: 'left'
          paddingBottom: 36
          margin: '8px auto 0 auto'
          fontStyle: 'oblique'


        """Consider.it conversations stay focused — even if hundreds participate — so you can learn together, 
           make better decisions, and gain buy-in, without the overhead of expensive meetings or 
           overwhelming comment threads."""

        # """Consider.it conversations stay focused — even if hundreds participate — so you can learn together, 
        #    make better decisions, and gain buy-in, without expensive meetings or 
        #    overwhelming comment threads."""

      # DIV 
      #   style: 
      #     position: 'relative'
      #     zIndex: 2
      #     backgroundColor: 'white'
      #     boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)'
      #     paddingTop: 30
      #     paddingBottom: 70



      #   DIV 
      #     style: 
      #       marginTop: 20
      #     TestimonialGrid 
      #       testimonials: [testimonials.pierre, testimonials.auryn]
      #       maxWidth: 900
      #       top: false 
      #       italic: true


      # nav sections
      DIV 
        style: 
          paddingBottom: 60
          width: SAAS_PAGE_WIDTH()

          margin: 'auto'
        if mobile 
          for section in nav
            DIV 
              style: 
                textAlign: 'center'
                paddingBottom: 20                

              section_div section

        else 
          rows = [[nav[0], nav[1]],[nav[2], nav[3]] ]
          TABLE 
            style:
              margin: 'auto'
              borderSpacing: '80px 24px'
              borderCollapse: 'separate'
            
            for row in rows 
              TR 
                style: {}

                for section, idx in row
                  TD 
                    style: 
                      width: '48%'
                      textAlign: if idx == 0 then 'right' else 'left'

                    section_div section

nav = [

  {
    label: 'How does it work?'
    link: '/tour'
    links: [
      {
        label: 'starting your own forum'
        link: '/tour'
      }, 
      {
        label: 'features'
        link: '/tour#features'
      }, 
      # {
      #   label: 'compare to surveys & more'
      #   link: '/tour#compare'
      # }, 
      {
        label: 'research findings'
        link: '/tour#research'
      }
    ]
  }, 

  {
    label: 'Show me examples!'
    link: '/examples'
    links: [
      {
        label: 'strategic planning on a tight budget'
        link: '/examples/strategic_planning'
      }, 
      {
        label: 'civil public engagement'
        link: '/examples/public_engagement'
      }, 
      {
        label: 'decentralized community decision-making'
        link: '/examples/decentralized_decisions'
      }, 
      # {
      #   label: 'Something Else'
      #   link: ''
      # }
    ]
  }, {
    label: 'What will it cost?'
    link: '/pricing'
    links: [
      {
        label: 'free, unlimited & enterprise tiers'
        link: '/pricing'
      }, 
      {
        label: 'consulting services'
        link: '/pricing#consulting'
      }, 
      {
        label: 'FAQ'
        link: '/pricing#faq'
      }
    ]
  },

  {
    label: 'I\'d like to talk'
    link: '/contact'
    links: [
      {
        label: 'request a demo'
        link: '/contact?form=request_demo'
      },       
      {
        label: 'general inquiry'
        link: '/contact'
      }
      # {
      #   label: 'Our History'
      #   link: '/contact#history'
      # }, 
      # {
      #   label: 'Our Team'
      #   link: '/contact#team'
      # }
    ]
  }
]

section_div = (section) -> 
  DIV null,
    H3 
      style: 
        paddingBottom: 10
      A 
        href: section.link
        style: 
          textDecoration: 'underline' 
          fontStyle: 'oblique'
          color: 'white'
          fontSize: 42
          fontWeight: 800

        section.label 

    UL 
      style: 
        listStyle: 'none'
        

      for link, idx in section.links
        LI 
          style:
            textAlign: 'center'
            opacity: .7
            display: 'inline'
          A 
            href: link.link
            style: 
              #textDecoration: 'underline'
              fontSize: 18
              fontWeight: 400
              #fontStyle: 'oblique'
              color: 'white'

            link.label
          if idx < section.links.length - 1
            ', '



window.Demo = ReactiveComponent
  displayName: 'Demo'

  render: -> 
    if !@local.playing?
      @local.playing = true 

    loc = fetch('location')
    props = @props
    watch_demo = -> 
      window.scrollTo(0,0)    
      loc.query_params.play_demo = true 
      save loc 
    
    video_height = Math.max(200, 1.0 * props.width * 3 / 7)
    
    DIV 
      style:
        position: 'relative'
        width: props.width
        height: props.height
        margin: 'auto'
        #cursor: 'pointer'

      
      Webframe
        browser_loc: 'https://seattle2035.consider.it/housing'
        width: video_height * 7 / 3 + 2
        dummy: video_height
        dummy2: @local.playing

        DIV 
          style: 
            width: '100%'
            margin: 'auto'
            position: 'relative'

          VIDEO
            ref: 'video'
            preload: true
            loop: true
            autoPlay: true
            style: 
              width: video_height * 7 / 3
              height: video_height
              paddingTop: 10
              display: 'block'


            for format in ['mp4', 'webm']
              asset_path = asset("product_page/trimmed-overall.#{format}")
              #if asset_path?.length > 0
              SOURCE
                key: format
                src: asset_path
                type: "video/#{format}"

            "Your browser does not support the video element."

          DIV 
            style: 
              position: 'absolute'
              right: 6
              bottom: 6
              backgroundColor: '#534B4B'
              opacity: .7
              padding: '6px 12px'
              borderRadius: 8
              fontSize: 24

            BUTTON 
              style: 
                cursor: 'pointer'
                backgroundColor: 'transparent'
                border: 'none'
                color: 'white'
                width: 33
                display: 'inline-block'
              title: if @local.playing then 'Pause video demo' else 'Play video demo'
              onClick: => 
                @toggleVideoPlay()
              onKeyPress: => 
                if e.which == 32 || e.which == 13
                  @toggleVideoPlay()

              if !@local.playing 
                SPAN 
                  dangerouslySetInnerHTML: 
                    __html: '&#9658;'
              else 

                [SPAN 
                  dangerouslySetInnerHTML: 
                    __html: '&#10073'
                SPAN 
                  style: 
                    paddingLeft: 1
                  dangerouslySetInnerHTML: 
                    __html: '&#10073'
                ]

            BUTTON 
              style: 
                color: 'white'
                marginLeft: 6
                display: 'inline-block'
                cursor: 'pointer'
                backgroundColor: 'transparent'
                border: 'none'
              title: 'Restart video demo'
              onClick: => 
                @restart()
              onKeyPress: => 
                if e.which == 32 || e.which == 13
                  @restart()

              dangerouslySetInnerHTML: 
                __html: '&#10226;'

  
  toggleVideoPlay: -> 
    el = @refs.video?.getDOMNode()

    if @local.playing 
      el.pause?()
    else 
      el.play?()

    @local.playing = !@local.playing
    save @local 

    document.activeElement.blur()

  restart: -> 
    el = @refs.video?.getDOMNode()
    el.currentTime = 0
    document.activeElement.blur()




window.Webframe = ReactiveComponent
  displayName: 'Webframe'

  render: -> 

    DIV 
      style: 
        backgroundColor: 'white'
        borderRadius: 4
        boxShadow: '0 2px 8px rgba(0,0,0,.1)'
        border: '1px solid #DADADA'
        borderTop: 'none'
        width: @props.width or 882
        margin: 'auto'
      # aspect: 26/882
      SVG 
        viewBox: "0 0 882 26"
        width: (@props.width or 882) - 1
        height: 26/882 * ((@props.width or 882) - 1)
        style: 
          borderRadius: '4px 4px 0 0'
          position: 'relative'
          top: -1
          display: 'block'


        dangerouslySetInnerHTML: {__html: """
          <defs>
              <linearGradient x1="50%" y1="0%" x2="50%" y2="97.915338%" id="linearGradient-1">
                  <stop stop-color="#F6F4F6" offset="0%"></stop>
                  <stop stop-color="#D5D5D5" offset="99.5416135%"></stop>
                  <stop stop-color="#B7B6B7" offset="100%"></stop>
              </linearGradient>
              <rect id="path-2" x="0" y="0" width="882" height="25" rx="0"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-3">
                  <feOffset dx="0" dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"></feComposite>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-4">
                  <feGaussianBlur stdDeviation="0.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
                  <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <rect id="path-5" x="0" y="0" width="361.581259" height="14.1025641" rx="3.5"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-6">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feColorMatrix values="0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-7">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <rect id="path-8" x="0" y="0.606608157" width="16.4648609" height="14.1025641" rx="3.5"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-9">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feColorMatrix values="0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-10">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <rect id="path-11" x="0" y="0.606608157" width="17.1105417" height="14.1025641" rx="3.5"></rect>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-12">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                  <feColorMatrix values="0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0" type="matrix" in="shadowOffsetOuter1"></feColorMatrix>
              </filter>
              <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-13">
                  <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1"></feOffset>
                  <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"></feComposite>
                  <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0" type="matrix" in="shadowInnerInner1"></feColorMatrix>
              </filter>
              <ellipse id="path-14" cx="29.7013177" cy="4.45706419" rx="3.87408492" ry="3.87196696"></ellipse>
              <mask id="mask-15" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="7.74816984" height="7.74393392" fill="white">
                  <use xlink:href="#path-14"></use>
              </mask>
              <ellipse id="path-16" cx="16.7877013" cy="4.43125108" rx="3.87408492" ry="3.84615385"></ellipse>
              <mask id="mask-17" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="7.74816984" height="7.69230769" fill="white">
                  <use xlink:href="#path-16"></use>
              </mask>
              <ellipse id="path-18" cx="3.87408492" cy="4.43125108" rx="3.87408492" ry="3.84615385"></ellipse>
              <mask id="mask-19" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox" x="0" y="0" width="7.74816984" height="7.69230769" fill="white">
                  <use xlink:href="#path-18"></use>
              </mask>
          </defs>
          <g id="landing-page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Desktop-HD-Copy-34" transform="translate(-328.000000, -749.000000)">
                  <g id="Safari" transform="translate(328.000000, 750.000000)">
                      <g id="background">
                          <use fill="black" fill-opacity="1" filter="url(#filter-3)" xlink:href="#path-2"></use>
                          <use fill-opacity="0.6" fill="url(#linearGradient-1)" fill-rule="evenodd" xlink:href="#path-2"></use>
                          <use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-2"></use>
                      </g>
                      <!-- 
                      <g id="New-Tab" transform="translate(866.503660, 8.974359)">
                          <rect id="background" fill-opacity="0.5" fill="#B6B6B6" x="0" y="0" width="15.4963397" height="16.025641"></rect>
                          <path d="M7.74816984,7.69230769 L4.51976574,7.69230769 L4.51976574,8.33763552 L7.74816984,8.33763552 L7.74816984,11.5857856 L8.39385066,11.5857856 L8.39385066,8.33763552 L11.6222548,8.33763552 L11.6222548,7.69230769 L8.39385066,7.69230769 L8.39385066,4.48717949 L7.74816984,4.48717949 L7.74816984,7.69230769 Z M0.64568082,0 L15.4963397,0 L15.4963397,0.645327827 L0.64568082,0.645327827 L0.64568082,0 Z M0,0 L0.64568082,0 L0.64568082,15.376011 L0,15.376011 L0,0 Z" id="Add" fill="#7D7D7D"></path>
                      </g>
                      -->


                      <g id="Search" transform="translate(260.209370, 5.162623)" style="#{if @props.browser_loc?.length > 0 then '' else 'display:none'}">
                          <g id="background">
                              <use fill="black" fill-opacity="1" filter="url(#filter-6)" xlink:href="#path-5"></use>
                              <use fill="#FCFBFC" fill-rule="evenodd" xlink:href="#path-5"></use>
                              <use fill="black" fill-opacity="1" filter="url(#filter-7)" xlink:href="#path-5"></use>
                          </g>
                          <path d="M352.865451,3.86914807 C351.055024,4.03175239 349.636164,5.55230111 349.636164,7.40406126 C349.636164,9.36428721 351.22611,10.9533643 353.187408,10.9533643 C355.148707,10.9533643 356.738653,9.36428721 356.738653,7.40406126 C356.738653,7.29529458 356.733758,7.18767059 356.724176,7.08139735 L356.075239,7.08139735 C356.086957,7.18733884 356.092972,7.29499793 356.092972,7.40406126 C356.092972,9.00788249 354.792107,10.3080365 353.187408,10.3080365 C351.58271,10.3080365 350.281845,9.00788249 350.281845,7.40406126 C350.281845,5.90900072 351.41226,4.67781842 352.865451,4.51771221 L352.865451,5.79162418 L356.09209,4.17742213 L352.865451,2.56322008 L352.865451,3.86914807 Z" id="reload" fill="#7E7E7E"></path>
                          <text id="url" font-family="HelveticaNeue, Helvetica Neue" font-size="10" font-weight="normal" letter-spacing="-0.15384616" fill="#000000">
                              <tspan x="19.6134701" y="10.5641026">#{@props.browser_loc}</tspan>
                          </text>
                      </g>
                      <g id="Back-+-Forward" transform="translate(50.363104, 4.521597)">
                          <g id="forward" transform="translate(17.756223, 0.000000)">
                              <g id="background">
                                  <use fill="black" fill-opacity="1" filter="url(#filter-9)" xlink:href="#path-8"></use>
                                  <use fill="#FCFBFC" fill-rule="evenodd" xlink:href="#path-8"></use>
                                  <use fill="black" fill-opacity="1" filter="url(#filter-10)" xlink:href="#path-8"></use>
                              </g>
                              <g id="Icon" transform="translate(6.779649, 4.190329)" stroke="#DADADA" stroke-width="1.5" stroke-linecap="round">
                                  <path d="M0.161420205,0.161331957 L3.425862,3.42398908" id="Line"></path>
                                  <path d="M0.161420205,6.69625979 L3.425862,3.43360266" id="Line"></path>
                              </g>
                          </g>
                          <g id="back">
                              <g id="background">
                                  <use fill="black" fill-opacity="1" filter="url(#filter-12)" xlink:href="#path-11"></use>
                                  <use fill="#FCFBFC" fill-rule="evenodd" xlink:href="#path-11"></use>
                                  <use fill="black" fill-opacity="1" filter="url(#filter-13)" xlink:href="#path-11"></use>
                              </g>
                              <g id="Icon" transform="translate(7.685212, 7.690329) scale(-1, 1) translate(-7.685212, -7.690329) translate(5.685212, 4.190329)" stroke="#585858" stroke-width="1.5" stroke-linecap="round">
                                  <path d="M0.161420205,0.161331957 L3.425862,3.42398908" id="Line"></path>
                                  <path d="M0.161420205,6.69625979 L3.425862,3.43360266" id="Line"></path>
                              </g>
                          </g>
                      </g>
                      <g id="Close-+-Minimize-+-Full-Screen" transform="translate(8.393851, 7.748236)">
                          <use id="green" stroke="#19B228" mask="url(#mask-15)" fill="#14CA34" xlink:href="#path-14"></use>
                          <use id="yellow" stroke="#E3A300" mask="url(#mask-17)" fill="#FFC008" xlink:href="#path-16"></use>
                          <use id="red" stroke="#E4453A" mask="url(#mask-19)" fill="#FF5F52" xlink:href="#path-18"></use>
                      </g>
                  </g>
              </g>
          </g>
          """}

      @props.children 




# UseCases = ReactiveComponent
#   displayName: 'UseCases'

#   render: -> 

#     uses = [
#       {
#         title: 'To engage the public'
#         subtitle: 'in giving focused feedback on plans and policy'
#         example_text: 'City of Seattle'
#         img: 'seattle_logo.png'
#         example: 'https://hala.consider.it'
#         img_dim: {height: 97, width: 98}
#         link: null,
#         color: '#007BC6'
#       },
#       {
#         title: 'To align behind a new strategic plan'
#         subtitle: 'by engaging staff, board, and other stakeholders'
#         example_text: 'WSFFN'
#         img: 'wsffn_logo.png'
#         example: 'https://wsffn.consider.it'   
#         img_dim: {height: 72, width: 90}     
#         link: null
#         color: '#6C7C00'
#       },
#       {
#         title: 'To organize community ideas'
#         subtitle: 'for taking collective action'
#         example_text: 'The DAO'
#         img: 'dao_logo.png'
#         example: 'https://dao.consider.it'
#         img_dim: {height: 72, width: 72}
#         link: null
#         color: '#D1170B'
#       },
#       {
#         title: 'To do something else '
#         subtitle: 'that we weren’t expecting!'
#         example_text: ''
#         img: 'rupaul_logo.png'
#         example: 'https://rupaul.consider.it'
#         img_dim: {height: 93, width: 220}        
#         link: null
#         color: '#D600B1'
#       },

#     ]


#     DIV 
#       style: 
#         backgroundColor: 'white'


#       DIV
#         style: 
#           width: SAAS_PAGE_WIDTH()
#           margin: 'auto'

#         H2
#           style: 
#             fontSize: 28
#             fontWeight: 400
#             textAlign: 'left'
#             paddingTop: 0
#             fontWeight: 200

#           'Example uses'

#         TABLE 
#           style: 
#             width: '100%'
#             borderCollapse: 'collapse'

#           TBODY null,
#             for use, idx in uses
#               TR 
#                 style: 
#                   height: 140
#                   borderTop: if idx > 0 then '1px solid #DDD'
#                   #borderBottom: if idx == uses.length - 1 then '1px solid #CBC8C8'

#                 TD 
#                   style: 
#                     verticalAlign: 'middle'

#                   DIV 
#                     style: 
#                       fontSize: 24
#                       fontWeight: 700
#                     use.title 

#                   DIV   
#                     style: 
#                       fontSize: 18
#                     use.subtitle
#                 TD 
#                   style: 
#                     fontStyle: 'italic'
#                     textAlign: 'center'
#                     fontSize: 18
#                     verticalAlign: 'middle'
#                     padding: '0 80px'
#                   'like'

#                 TD
#                   style: 
#                     verticalAlign: 'middle'


#                   A 
#                     href: use.example
#                     target: '_blank'
#                     style: 
#                       fontSize: 18
#                       fontWeight: 700
#                       color: use.color 

#                     SPAN 
#                       style: 
#                         display: 'inline-block'
#                         width: 100
#                         textAlign: 'center'                      

#                       IMG 
#                         src: asset("product_page/#{use.img}")
#                         style: 
#                           width: use.img_dim.width
#                           height: use.img_dim.height 
#                           verticalAlign: 'middle'

#                     SPAN 
#                       style: 
#                         fontSize: 24
#                         fontWeight: 500
#                         paddingLeft: 20
#                         verticalAlign: 'middle'
#                       use.example_text

#                 TD 
#                   style: 
#                     verticalAlign: 'middle'  

#                   A 
#                     href: use.example
#                     style: 
#                       fontSize: 18
#                       fontWeight: 700
#                       textDecoration: 'underline'
#                       color: use.color 
#                     target: '_blank'

#                     'visit example'







/** WEBPACK FOOTER **
 ** ./@client/product_page/landing_page.coffee
 **/